import clsx from 'clsx';

import type { TimeProgressProps } from './TimeProgress.types';
import classes from './TimeProgress.module.css';
import { Text } from '../../components/Text';

export const TimeProgress = (props: TimeProgressProps) => {
    const { showTime, progress, startTime = '00:00', endTime = '00:00', className } = props;

    return (
        <div className={clsx(classes.root, className)}>
            {showTime && <Text text={startTime} />}

            <div className={classes.progressPath}>
                <div
                    className={classes.progressThumb}
                    data-testid="progress-bar"
                    style={{
                        width: `${progress}%`,
                        transition: progress === 100 ? 'none' : 'width 0.1s linear',
                    }}
                />
            </div>

            {showTime && <Text text={endTime} />}
        </div>
    );
};

TimeProgress.displayName = 'TimeProgress';
